<template>
  <div>
    <div class="mx-2 mt-4 flex justify-between">
      <div class="w-1/2">
        <input
          v-model="search"
          class="w-full"
          placeholder="Search Membership Groups"
          type="text"
        >
      </div>
      <div>
        <button
          type="button"
          class="btn"
          @click="openGroupCreationModal"
          v-text="'Create New Group'"
        />
      </div>
    </div>
    <div v-if="membershipGroups.length">
      <section class="flex flex-wrap items-stretch justify-between">
        <div
          v-for="membershipGroup in membershipGroups"
          :key="membershipGroup.uuid"
          class="flex w-full sm:w-1/2 md:w-1/3 lg:w-1/4 xl:w-1/5 min-w-card"
        >
          <div class="card card-bio-content card--interactive text-center">
            <h6
              class="text-blue uppercase -mt-2 mb-4"
              v-text="membershipGroup.attributes.type"
            />
            <h2
              class="mb-1"
              v-text="membershipGroup.attributes.title"
            />
            <p
              class="italic"
              v-text="membershipGroup.attributes.description"
            />
            <h5
              class="mt-0 mb-4 uppercase"
              v-text="membershipCount(membershipGroup.attributes.membership_count)"
            />
            <div class="flex justify-around">
              <input
                :id="`membership-group-${membershipGroup.uuid}`"
                v-model="selectedGroups"
                :name="`membership-group-${membershipGroup.uuid}`"
                :value="membershipGroup.uuid"
                type="checkbox"
              >
              <label
                :for="`membership-group-${membershipGroup.uuid}`"
                v-text="'Add to group'"
              />
            </div>
          </div>
        </div>
      </section>
      <div class="flex justify-center mb-6">
        <input
          :value="confirmationText"
          class="btn"
          type="submit"
          @click.prevent="save"
        >
      </div>
    </div>
    <section
      v-else
      class="empty"
    >
      <section>
        <h2 v-text="'There are no assignable groups'" />
      </section>
    </section>
    <CreateMembershipGroupModal @membershipGroupHasBeenCreated="membershipGroupHasBeenCreated" />
  </div>
</template>

<script type="text/babel">
import { mapActions, mapState } from 'vuex'
import { debounce } from 'lodash'

export default {
  name: 'MembershipGroupAssigner',
  props: {
    membershipUuid: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
      search: '',
      selectedGroups: [],
    }
  },
  computed: {
    ...mapState({
      membershipGroups: state => state.membership.membershipGroups.data,
    }),
    confirmationText() {
      return this.selectedGroups.length === 1
        ? 'Add to 1 Group'
        : `Add to ${this.selectedGroups.length} Groups`
    },
  },
  watch: {
    search: debounce(function () {
      this.fetchMembershipGroups({
        params: {
          query: this.search,
        },
      })
    }, 500),
  },
  async mounted() {
    await this.$nextTick()

    this.fetchMembershipGroups()
  },
  methods: {
    ...mapActions({
      fetchMembershipGroups: 'membershipGetMembershipGroups',
      assignMembershipGroups: 'membershipAssignMembershipGroups',
    }),
    save() {
      this.assignMembershipGroups({
        payload: {
          membershipGroupUuids: this.selectedGroups,
        },
        membershipUuid: this.membershipUuid,
      }).then((response) => {
        if (response.data.status === 'success') {
          this.$emit('membershipGroupsHaveBeenAssigned')
        }
      })
    },
    membershipGroupHasBeenCreated(membershipGroup) {
      this.fetchMembershipGroups({
        params: {
          query: this.search,
        },
      })

      this.selectedGroups.push(membershipGroup.uuid)
    },
    openGroupCreationModal() {
      this.$store.commit('membershipOpenCreateMembershipGroupModal')
    },
    membershipCount(count) {
      return count === 1
        ? '1 member'
        : `${count} members`
    },
  },
}
</script>
